import { mapStores } from 'pinia'
import useBcSelectedStore from '@/frontapp/store/bcSelected'
import useBcFolderStore from '@/frontapp/store/bcFolder'
import DragDropElement from './DragDropElement'
import defaults from 'lodash/defaults'
import findIndex from 'lodash/findIndex'
import ToggleCommentResolver from '@/frontapp/mixins/ToggleCommentResolver'
import DocumentStore from '@/frontapp/mixins/DocumentStore'
import UpdateDocumentRevision from '@/frontapp/mixins/actions/UpdateDocumentRevision'

export default {
  mixins: [DragDropElement, DocumentStore, ToggleCommentResolver],
  props: {
    element: {
      type: Object,
      required: true,
    },
    parent: {
      type: Object,
      required: true,
    },
    page: {
      type: Object,
      required: true,
    },
    index: Number,
    last: {
      type: Boolean,
      default: false
    },
    isPageLocked: {
      type: Boolean,
      default: false
    },
    isUpdateDisabled: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      focused: null, // focused data element
      metaData: {}, // data which are added to create/update element request
    }
  },
  computed: {
    ...mapStores(useBcSelectedStore, useBcFolderStore),
    data() {
      return this.element?.data
    },
    edit() {
      return this.bcDocumentStore.edit
    },
    isEveryElementLocked() {
      let hasElements = false
      for (let e of this.bcSelectedStore.selectableMap.values()) {
        if (!e.locked) {
          return false
        }
        hasElements = true
      }

      return hasElements
    },
    updated: {
      get() {
        if (this.element?.updated) {
          return this.element?.updated
        }
        return false
      },
      set(val) {
        this.element.updated = val
      }
    },
    isLastOnPage() {
      if (this.parent.type === 'page') {
        if (this.element.type !== 'header') {
          return (this.index + 1) === this.parent.children.length
        } else {
          return (this.index + 1) === this.parent.children.length && this.element.children.length === 0
        }
      } else { // parent is header
        const parentIndex = findIndex(this.page.children, ['id', this.parent.id])
        return (parentIndex + 1) === this.page.children.length && (this.index + 1) === this.parent.children.length
      }
    }
  },
  methods: {
    async deleteElement() {
      const element = this.element
      const bcDocumentStore = this.bcDocumentStore
      const $router = this.$router
      const bcSelectedStore = this.bcSelectedStore
      bcDocumentStore.deleteElementsRecursive([element.id])
      await bcDocumentStore.deleteElements(
        [element],
        async (documentRev, resolve) => {
          if (documentRev.id !== bcDocumentStore.documentRev) {
            await UpdateDocumentRevision(bcDocumentStore, documentRev.id, $router)
          } else {
            bcSelectedStore.reload()
          }
          resolve()
        }
      )
    },
    mergeElementData(elementData, updatedElData) {
      if (!this.$options?.updateDataKeys) {
        return
      }
      Object.keys(updatedElData).forEach((key) => {
        if (this.$options.updateDataKeys.includes(key)) {
          elementData[key] = updatedElData[key]
        }
      })
    },
  },
  watch: {
    updated: {
      handler(val) {
        if (!val || this.$options?.disableUpdate || this.isUpdateDisabled) return

        this.focused = null

        // handle metadata and freeze updated data key value
        let metaData = { ...this.metaData }
        if (this.element.metaData) {
          metaData = { ...metaData, ...this.element.metaData }
          delete this.element.metaData
        }

        if (val !== true) { // freeze updated data key
          if (Array.isArray(this.data[val])) {
            metaData[val] = [ ...this.data[val] ]
          
          } else {
            metaData[val] = this.data[val]
          }
        }
        this.metaData = {}

        this.$nextTick(async () => {
          this.updated = false

          // if parent id is not set, we cant create / update element
          if (
            !this.element.parent__bc_document_data_rev_id &&
            this.element.type !== 'page'
          ) {
            return
          }

          // update document name in folder list
          if (this.element.type === 'page' && this.element.rank === 0 && this.bcDocumentStore.document.published__bc_document_rev_id === null) {
            this.bcFolderStore.hashTableDocuments[this.bcDocumentStore.document.id].name = this.element.data.header
          }

          const bcDocumentStore = this.bcDocumentStore
          const element = this.element
          const $router = this.$router
          const bcSelectedStore = this.bcSelectedStore

          console.log('baseElement bcDocumentStore.saveElement')
          
          bcDocumentStore.saveElement(
            element,
            metaData,
            async (savedElement, resolve) => {
              let reloadSelectedStore = false
              this.mergeElementData(element.data, savedElement.data)
              if (element.id === undefined) {
                delete savedElement.key
                defaults(element, savedElement)
                element.parent__bc_document_data_rev_id = savedElement.parent__bc_document_data_rev_id // may change over revision
                reloadSelectedStore = true
              }

              bcDocumentStore.addToFlatten(element)

              if (
                savedElement.bc_document_rev_id !==
                bcDocumentStore.documentRev
              ) {
                await UpdateDocumentRevision(bcDocumentStore, savedElement.bc_document_rev_id, $router)
              
              } else if (reloadSelectedStore) {
                bcSelectedStore.resetSelected()
                bcSelectedStore.selectableMap.set(element.id, element)
              }

              if (element.children) {
                element.children.forEach((el) => {
                  if (
                    el.id === undefined ||
                    el.parent__bc_document_data_rev_id === undefined
                  ) {
                    el.parent__bc_document_data_rev_id = savedElement.id
                    el.updated = true
                  }
                })
              }

              console.log('added element resolved')
              try { // this next tick can be undefined, when component unmount when document changed -> uploads and leave document
                this.$nextTick(() => {
                  resolve()
                })
              } catch (e) {
                resolve()
              }
            }
          )
        })
      },
      immediate: true
    }
  },
}
